<script lang="ts" setup>
import { Account, formatTime, Season } from '@wastedondestiny/destiny-library'
import { computed } from 'vue'

const props = defineProps<{
  player: Account,
  detailedActivities?: Record<string, number>,
  loading?: boolean
}>()

const oldSeasons: Season[] = [
  { number: 1, season: 'Red War', seasonPrestige: 0, seasonRank: 0 },
  { number: 2, season: 'Curse of Osiris', seasonPrestige: 0, seasonRank: 0 },
  { number: 3, season: 'Warmind', seasonPrestige: 0, seasonRank: 0 },
  { number: 4, season: 'Season of the Outlaw', seasonPrestige: 0, seasonRank: 0 },
  { number: 5, season: 'Season of the Forge', seasonPrestige: 0, seasonRank: 0 },
  { number: 6, season: 'Season of the Drifter', seasonPrestige: 0, seasonRank: 0 },
  { number: 7, season: 'Season of Opulence', seasonPrestige: 0, seasonRank: 0 }
]

const allSeasons = computed(() => ([...oldSeasons, ...(props.player.seasons || [])]))
</script>

<template>
  <h3 class="font-sans text-xl -mt-4 pt-3 -mx-3 px-3 pb-1 w-[calc(100%+1.5rem)] sticky top-0 bg-zinc-200 border-zinc-400 border-b rounded-t-lg shadow-md">Time per season: {{ player.displayName }}</h3>

  <div v-if="loading" class="text-3xl leading-7 font-serif font-bold flex gap-2 justify-center items-center h-40">
    <span class="transition-opacity bullet-1">&bullet;</span>
    <span class="transition-opacity bullet-2">&bullet;</span>
    <span class="transition-opacity bullet-3">&bullet;</span>
  </div>
  <div v-else class="font-sans grid grid-cols-1 lg:grid-cols-2 gap-x-2 pt-1">
    <div class="flex justify-between items-center border-b-zinc-200" :class="{ 'border-b': i < 24 }" v-for="(season, i) in allSeasons">
      <small class="text-sm"><span class="w-5 inline-block text-zinc-500 tabular-nums">{{ season.number }}</span>&bullet; {{ season.season }}</small>
      <span class="font-semibold tabular-nums">{{ formatTime(detailedActivities?.[season.number] || 0) }}</span>
    </div>
  </div>
</template>